<ng-template #modalContent let-modal>
    <div id="payByBankModal" class="modal-body pay-by-bank-modal" *transloco="let t">
        <div class="modal-header">
            <h2 class="title">{{ t('paybybank.stub.title') }}</h2>
            <button type="button" class="btn-close" (click)="dismissModal('Cross click'); sendTxRejectStatus()" aria-label="Close modal">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-content-wrapper">
            <!-- Error message -->
            <div class="alert alert-danger" role="alert" *ngIf="paymentStatus && paymentStatus === 'paymentError'" aria-live="assertive">
                {{ t('paybybank.error.stub.decline') }}
            </div>

            <!-- Payment redirect form -->
            <app-merchant-response #merchantResponseComponent></app-merchant-response>

            <!-- PayByBank Stub UI -->
            <div class="pay-by-bank">
                <form #stubForm="ngForm" role="form" aria-labelledby="status-label">
                    <div class="status-label" id="status-label">{{ t('paybybank.stub.select.status') }}</div>
                    <div class="form-check-group">
                        <div class="form-check">
                            <input id="success" type="radio" required #userchoice="ngModel" value="APPROVED" 
                                   name="status" [(ngModel)]="stubUserChoice" class="form-check-input"
                                   (change)="onStubChoiceSelected('APPROVED')">
                            <label class="form-check-label" for="success">{{ t('paybybank.stub.success') }}</label>
                        </div>
                        <div class="form-check">
                            <input id="cancel" type="radio" required #userchoice="ngModel" value="CANCEL" 
                                   name="status" [(ngModel)]="stubUserChoice" class="form-check-input"
                                   (change)="onStubChoiceSelected('CANCEL')">
                            <label class="form-check-label" for="cancel">{{ t('paybybank.stub.cancel') }}</label>
                        </div>
                        <div class="form-check">
                            <input id="failed" type="radio" required #userchoice="ngModel" value="ERROR" 
                                   name="status" [(ngModel)]="stubUserChoice" class="form-check-input"
                                   (change)="onStubChoiceSelected('ERROR')">
                            <label class="form-check-label" for="failed">{{ t('paybybank.stub.failed') }}</label>
                        </div>
                        <div class="alert alert-danger" *ngIf="userchoice.touched && userchoice.invalid" role="alert">
                            {{ t('paybybank.stub.select.option') }}
                        </div>
                    </div>
                    <button type="button" id="payByBankStubBtn" name="PayByBank" class="btn btn-primary"
                            (click)="submitPayByBankStub()" [disabled]="!stubForm.valid" aria-label="Submit payment">
                        {{ t('paybybank.stub.pay') }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</ng-template>